module.exports = __webpack_public_path__ + "img/familia.63757a04.svg";